import script from "./TabHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./TabHeader.vue?vue&type=script&setup=true&lang=js"

import "./TabHeader.vue?vue&type=style&index=0&id=23180f41&scoped=true&lang=css"

import exportComponent from "D:\\nodejs\\sws03\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23180f41"]])

export default __exports__